"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ErrorMessage = function ErrorMessage(_ref) {
  var error = _ref.error,
      children = _ref.children;
  return _react.default.createElement("p", {
    className: "text-center"
  }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faExclamationTriangle
  }), ' ', error.message, ' ', children);
};

ErrorMessage.propTypes = {
  error: _propTypes.default.object.isRequired,
  children: _propTypes.default.object
};
ErrorMessage.defaultProps = {
  children: undefined
};
var _default = ErrorMessage;
exports.default = _default;